<template>
  <div>
    <div class="textarea">
      <a class="save" v-show="saveIconStatus" @click="save()"
        ><font-awesome-icon icon="save"
      /></a>
      <textarea 
        rows="5"
        :placeholder="placeholder"
        :value="textValue"
        @input="textValue = $event.target.value"
      ></textarea>
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    "font-awesome-icon": FontAwesomeIcon,
    quillEditor
  },
  props: {
    code: String,
    name: String,
    value: String,
    placeholder: String,
    dbTable: String
  },
  data() {
    return {
      textValue: this.value,
      type: 'content'
    };
  },
  computed: {
    saveIconStatus() {
      return this.value !== this.textValue;
    }
  },
  methods: {
    save() {
      console.log("save");
      if (this.saveIconStatus) {
        this.$emit("input", this.textValue);
        this.$emit("update-input", {
          code: this.code,
          name: this.name,
          dbTable: this.dbTable,
          mutation: this.textValue,
          origin: this.value,
          type: this.type,
          warning: this.saveIconStatus
        });
      }
    },
    emitEditStatusEventToParent() {
      let changeStatusData = {
        code: this.code,
        warning: this.saveIconStatus
      };
      this.$emit('change-edit-status', changeStatusData)
    }
  },
  watch: {
    saveIconStatus: function(newVal, oldVal) {
      this.emitEditStatusEventToParent();
    }
  }
};
</script>
<style scoped src="../../../src/assets/css/shop-console.css"></style>
